




































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { STORE_KEY } from "./_store";

@Component
export default class MonthCellDetailLog extends Vue {
  @Prop({ default: () => ({}) }) request!: any;
  @Prop({ default: () => ({}) }) meta!: any;
  @Prop({ default: null }) cellValue!: number | null;

  loading = false;
  errorMessage = "";
  detailType = "";
  dailyRows: any[] = [];
  calcBasis: any = {};

  mounted() {
    this.loadDetail();
  }

  get isFactTkDetail() {
    return this.detailType === "fact_tk";
  }

  get detailTypeLabel() {
    if (this.detailType === "zone") return "Зона";
    if (this.detailType === "green") return "Зелёный клиент";
    if (this.detailType === "fact_tk") return "Факт ТК";
    return this.detailType || "—";
  }

  get visibleDailyRows(): any[] {
    return this.dailyRows.filter((row) => this.rowWeightKg(row) > 1e-9);
  }

  rowWeightKg(row: any): number {
    if (this.isFactTkDetail) {
      return Number(row?.fact_quantity) || 0;
    }
    return Math.max(
      Number(row?.calculated_quantity) || 0,
      Number(row?.manual_quantity) || 0,
      Number(row?.final_quantity) || 0,
      Number(row?.fact_quantity) || 0,
    );
  }

  async loadDetail() {
    this.loading = true;
    this.errorMessage = "";

    try {
      const payload = await this.$store.dispatch(
        `${STORE_KEY}/loadMonthCellDetail`,
        this.request,
      );

      this.detailType = payload?.detail_type || "";
      this.dailyRows = Array.isArray(payload?.daily_rows) ? payload.daily_rows : [];
      this.calcBasis = payload?.calc_basis || {};

      if (
        typeof console !== "undefined" &&
        console.warn &&
        this.dailyRows.length === 0
      ) {
        console.warn("shipment-forecast-by-date:month-detail:empty", {
          request: this.request,
          calc_basis: this.calcBasis,
        });
      }
    } catch (error) {
      const e = error as any;
      this.errorMessage =
        e?.response?.data?.error || e?.message || "Ошибка загрузки детализации";
    } finally {
      this.loading = false;
    }
  }

  formatNum(value: any): string {
    const n = value != null ? Number(value) : NaN;
    if (Number.isNaN(n)) return "—";
    const filters = this.$options.filters as any;
    return filters?.numFormat ? filters.numFormat(n, "0,0.00") : String(n);
  }

  close() {
    this.$emit("close");
    const parent: any = this.$parent;
    if (parent && typeof parent.close === "function") parent.close();
  }
}
